import React, { Component } from "react";
import { setCirurgia } from "../../Libs/cirurgia";
import { getPaciente } from "../../Libs/paciente";
import { getHospitalbyId } from "../../Libs/hospital";
import Notificacao from "../../components/Notificacao";
import Loading from "../../components/Loading";
import Loader from "../../components/Loader";
import { Row, Col } from "reactstrap";
import DropDownHospital from "../../components/DropDownHospital";
import moment from "moment";
import { getLoggedInUser } from "../../helpers/authUtils";
import InputIcon from "../../gb-components/InputIcon";
import HeaderModal from "../../gb-components/HeaderModal";

import IconHora from '../../assets/svg/ic-contact-time.svg';
import IconData from '../../assets/svg/ic-actions-calendar.svg';
import IconProc from '../../assets/svg/medical_wallet.svg';

import {
  firebaseAuth,
  firebaseFire as Libfirebase,
} from "../../helpers/firebase-config";

export default class CadastroCirurgia extends Component {
  componentDidMount = () => {
    const id = this.props.id? this.props.id:this.props.match.params.id;
    getPaciente(id)
      .then(paciente => {
        this.setState({ paciente });
      })
      .catch(erro => console.log(erro));
    this.setState({ id });
  };

  state = {
    id: null,
    modalIsOpen: false,
    notifition: false,
    loading: false,
    solicitarMaterial: "",
    dataCirurgia: null,
    hora: "",
    idHospital: "",
    procedimento:''
  };

  componentDidMount() { }

  _setCadastro = async () => {
    const {
      id,
      solicitarMaterial,
      idHospital,
      dataCirurgia,
      hora,
      procedimento
    } = this.state;
    this.setState({ notifition: false, msg: "", nameclass: "" });
    if (solicitarMaterial) {
      const user = firebaseAuth.currentUser;
      let idProfissional = 0;
      await Libfirebase.collection("usuario")
        .where("email", "==", user.email)
        .get()
        .then(snap => {
          snap.forEach(doc => {
            if (doc.exists) {
              idProfissional = doc.id;
            } else {
            }
          });
        })
        .catch(erro => console.log(erro));

      const refProfissional = Libfirebase.collection("usuario").doc(
        idProfissional
      );
      getHospitalbyId(idHospital)
        .then(hospital => {
 
          const data = {
            refProfissional,
            SolicitarMaterial: solicitarMaterial,
            Hospital: hospital.hospital,
            DataCirurgia: dataCirurgia,
            HoraCirurgia: hora,
            Date: new Date(),
            DataCriacao: moment().format("DD-MM-YYYY"),
            procedimento
          };
          setCirurgia(data, id)
            .then(async () =>{
                this.setState({
                  notifition: true,
                  msg: "Cirurgia cadastrada com sucesso!",
                  nameclass: "alert-success"
                })
                await Libfirebase.collection("paciente")
                .doc(id)
                .update({ status: this.state.dataCirurgia ? "Agendado" : "Aguardando Cirurgia" })
                .catch(error => {
                  this.setState({
                    openModal: false,
                    status: null,
                    notifition: true,
                    msg: ("Houve um erro ao salvar o status", error),
                    nameclass: "alert-danger"
                  });
                });

                if(this.props.onClose){
                  this.props.onClose();
                }
              }
            )
            .catch(error =>
              this.setState({
                notifition: true,
                msg: error.msg,
                nameclass: "alert-danger"
              })
            );
        })
        .catch(error => {
          console.log(error);
        });
    } else {
      this.setState({
        notifition: true,
        msg: "Favor preencher todos os campos",
        nameclass: "alert-warning"
      });
    }
  };


  render() {
    if (getLoggedInUser().permissao.toString() != '3') {

      return (
        <React.Fragment>
          <div className="">
            {/* preloader */}
            {this.props.loading && <Loader />}

            <HeaderModal title="Cadastro de Cirurgia"/>

            <div>
              <Loading loading={this.state.loading} />
              {/* <div className="page-wrapper">
                <div className="page-breadcrumb"> */}
                  {/* <Link
                    to={this.props.onClose?"#":"/paciente/historico/" + this.state.id}
                    onClick={()=>{
                      if(this.props.onClose){
                        this.props.onClose();
                      }
                    }}
                    className="btn btn-outline-info btn-rounded"
                  >
                    <i className="fa fa-angle-left"></i> Voltar
                </Link>
                  <br />
                  <br /> */}
                  {this.state.notifition ? (
                    <Notificacao
                      msg={this.state.msg}
                      nameclass={this.state.nameclass}
                    />
                  ) : null}

                <form>
                  <Row>
                    <Col xs={12} md={6}>
                      <div>
                        <DropDownHospital
                          cidade={this.state.idHospital}
                          change={event =>
                            this.setState({
                              idHospital: event.target.value
                            })
                          }
                          style={{marginBottom:12, width:'100%'}}
                        />
                      </div>
                      <InputIcon
                        placeholder="Hora"
                        type="time"
                        id="dataCirurgia"
                        value={this.state.hora}
                        onChange={text => this.setState({ hora: text })}
                        style={{marginBottom:12, width:'100%'}}
                        icon={IconHora}
                      />
                      <InputIcon
                        placeholder="Data da Cirugia"
                        type="date"
                        id="dataCirurgia"
                        value={this.state.dataCirurgia}
                        onChange={text =>
                          this.setState({ dataCirurgia: text })
                        }
                      style={{ width: '100%', marginBottom: 12}}
                        icon={IconData}
                    />
                    <InputIcon
                      placeholder="Procedimento"
                      type="text"
                      id="txtProcedimento"
                      value={this.state.procedimento}
                      onChange={text =>
                        this.setState({ procedimento: text })
                      }
                      style={{ width: '100%' }}
                      icon={IconProc}
                    />
                    </Col>
                    <Col xs={12} md={6}>
                    <textarea
                      className="form-control"
                        placeholder="Solicitar Material"
                        type="textarea"
                        rows="4"
                        cols="60"
                        id="solicitarMaterial"
                        value={this.state.solicitarMaterial}
                        onChange={text =>
                          this.setState({ solicitarMaterial: text.target.value })
                        }
                        style={{ width:'100%', height:'100%'}}
                      />
                      </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col xs={12} md={12}>
                      <button
                        type="button"
                        onClick={() => this._setCadastro()}
                        className="btn gb-button to-form full"
                      >
                          Salvar
                      </button>
                    </Col>
                  </Row>
                </form>
                {this.state.notifition ? (
                  <Notificacao
                    msg={this.state.msg}
                    nameclass={this.state.nameclass}
                  />
                ) : null}
            </div>
          </div>
        </React.Fragment>
      );

    } else {
      return (<div className="alert alert-danger text-center">VOCÊ NÃO TEM PERMISSÃO DE ACESSO NESTA PÁGINA</div>)
    }
  }
}
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)"
  }
};
